import { createContext } from 'react';

var PortalContext = createContext(function () { return null; });

export { PortalContext };
